import { useEffect } from 'react'

import { digObject } from '@domain-group/javascript-utils'

import { useThunkDispatch } from '@domain-group/react-hooks'

import * as campaignActions from '@redux/modules/campaign'
import type { AppDispatch } from '@redux/store'

import type { AgencyModel, CampaignModel } from '@models/types'

import useCampaignSelector from './useCampaignSelector'

interface CampaignSyncParams {
  agency: AgencyModel,
  campaign: CampaignModel,
  dispatch: AppDispatch,
}

const performSync = (props: CampaignSyncParams) => {
  const { agency, campaign, dispatch } = props

  const { importCampaign: importFn } = campaignActions

  const crmSyncApi = digObject(agency, 'options.crm_sync_api')
  const externalApiId = digObject(campaign, 'data.external_api_id')

  if (crmSyncApi && externalApiId){
    const options = {
      agency_id: agency.id,
      include_campaign_agent_ids: true,
      include_campaign_agent_user_ids: true,
      include_campaign_image: true,
      include_campaign_sensitive_data: true,
      include_campaign_status: true,
    }

    return dispatch(importFn(externalApiId, options))
  }

  return false
}

const useCampaignSync = () => {
  const { agency, campaign } = useCampaignSelector()

  const dispatch = useThunkDispatch()

  useEffect(() => {
    if (agency.id && campaign.id) performSync({ agency, campaign, dispatch })
  }, [agency.id, campaign.id])

  return null
}

export default useCampaignSync
